import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RecipeCostAnalysis = ({ data, detailed = false }) => {
  const processData = () => {
    if (detailed) {
      // Show cost distribution by recipe
      const sortedRecipes = [...data].sort((a, b) => b.cost - a.cost).slice(0, 10);
      return {
        labels: sortedRecipes.map(recipe => recipe.name),
        datasets: [{
          label: 'Cost (₹)',
          data: sortedRecipes.map(recipe => recipe.cost),
          backgroundColor: 'rgba(79, 70, 229, 0.7)',
        }]
      };
    }

    // Show cost ranges
    const costRanges = ['< ₹100', '₹100-200', '₹200-300', '₹300-400', '> ₹400'];
    const counts = costRanges.map((range, i) => {
      if (i === 0) return data.filter(r => r.cost < 100).length;
      if (i === costRanges.length - 1) return data.filter(r => r.cost > 400).length;
      const min = 100 + (i - 1) * 100;
      const max = 100 + i * 100;
      return data.filter(r => r.cost >= min && r.cost < max).length;
    });

    return {
      labels: costRanges,
      datasets: [{
        label: 'Number of Recipes',
        data: counts,
        backgroundColor: [
          'rgba(59, 130, 246, 0.7)',
          'rgba(16, 185, 129, 0.7)',
          'rgba(245, 158, 11, 0.7)',
          'rgba(236, 72, 153, 0.7)',
          'rgba(139, 92, 246, 0.7)'
        ],
      }]
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            if (detailed) {
              return `₹${context.raw.toFixed(2)}`;
            }
            return `${context.raw} recipes`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    }
  };

  return <Bar data={processData()} options={options} />;
};

export default RecipeCostAnalysis;